import { UseQueryOptions, useQuery, useQueryClient, useMutation } from "react-query";
import { http } from "./http";
import { Account } from "../types";
import { CustomerDetails } from "src/features/hq/customers/models";

export function useAccount(ops?: UseQueryOptions<any>) {
  return useQuery<Account>({
    queryKey: ["/api/account"],
    queryFn: async () => {
      const resValue = await http("/api/account");

      if (!resValue.fullName && resValue.email) {
        resValue.fullName = resValue.email.split("@")[0];
      }

      return resValue;
    },
    ...ops
  });
}

export function useSaveAccount() {
  const queryClient = useQueryClient();

  return useMutation<any, unknown, CustomerDetails>({
    mutationFn: values => http(`/api/account`, { method: "POST", body: values }),
    onSuccess: (data: any) => queryClient.invalidateQueries(['/api/account'])
  });
}